<template>
	<div class="rolling-banner">
		<div class="logo-container">
			<a
				href="javascript:;"
				v-for="(logo, idx) in logoList"
				:key="`logo-${idx}`"
				:class="`logo-wrapper-${idx + 1} vertical-center`"
				><img :src="logo.src" :alt="logo.alt" :class="logo.class"
			/></a>
		</div>
	</div>
</template>

<script>
import { useStore } from '@vueblocks/vue-use-vuex';

export default {
	name: 'ciLogo',
	computed: {
		logoList() {
			const store = useStore();
			return [
				{
					src: require('@/assets/image/header_logo.png'),
					alt: 'giftishow-biz',
					class: 'biz-logo vertical-center',
				},
				{
					src: store.getters.userInfo.ciImageUrl,
					alt: 'ci-loog',
					class: 'ci-loog-image',
				},
			];
		},
	},
};
</script>

<style lang="less" scoped>
@keyframes flickerAnimation {
	0% {
		opacity: 0;
	}

	5% {
		opacity: 1;
	}

	45% {
		opacity: 1;
	}

	50% {
		opacity: 0;
	}

	100% {
		opacity: 0;
	}
}

.vertical-center {
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
}

.rolling-banner {
	position: relative;
	display: inline-block;
	width: 170px;
	height: 40px;
	overflow: hidden;

	.logo-container {
		position: relative;
		width: 100%;
		height: 100%;

		.logo-wrapper-1,
		.logo-wrapper-2 {
			transform: translateY(-50%);
			animation: flickerAnimation 6s infinite;
			width: 100%;
			height: 100%;

			img {
				display: block;
				max-width: 100%;
				width: auto;
				height: 100%;
				object-fit: contain;

				&.biz-logo {
					height: 22px;
				}
			}
		}

		.logo-wrapper-2 {
			opacity: 0;
			animation-delay: 3s;
		}
	}
}
</style>
